import { SVGProps } from 'react';
import { useColorTheme } from 'src/hooks';

export const DownloadAppsQr = ({
  width = 168,
  height = 168,
}: SVGProps<SVGSVGElement>) => {
  const { isDarkTheme } = useColorTheme();
  const fillColor = isDarkTheme ? '#11181B' : 'white';
  const ninjaIconColor = isDarkTheme ? '#E8EAEA' : '#1D282D';

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 168 168"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      fillOpacity="1"
    >
      <path d="M5.7931 0H0V5.7931H5.7931V0Z" fill={fillColor} />
      <path d="M5.7931 5.79321H0V11.5863H5.7931V5.79321Z" fill={fillColor} />
      <path d="M5.7931 11.5862H0V17.3793H5.7931V11.5862Z" fill={fillColor} />
      <path d="M5.7931 17.3794H0V23.1725H5.7931V17.3794Z" fill={fillColor} />
      <path d="M5.7931 23.1724H0V28.9655H5.7931V23.1724Z" fill={fillColor} />
      <path d="M5.7931 28.9656H0V34.7587H5.7931V28.9656Z" fill={fillColor} />
      <path d="M5.7931 34.7585H0V40.5516H5.7931V34.7585Z" fill={fillColor} />
      <path d="M5.7931 46.3447H0V52.1378H5.7931V46.3447Z" fill={fillColor} />
      <path d="M5.7931 57.9312H0V63.7243H5.7931V57.9312Z" fill={fillColor} />
      <path d="M5.7931 63.7241H0V69.5172H5.7931V63.7241Z" fill={fillColor} />
      <path d="M5.7931 69.5173H0V75.3104H5.7931V69.5173Z" fill={fillColor} />
      <path d="M5.7931 86.8965H0V92.6896H5.7931V86.8965Z" fill={fillColor} />
      <path d="M5.7931 92.6897H0V98.4828H5.7931V92.6897Z" fill={fillColor} />
      <path d="M5.7931 98.4827H0V104.276H5.7931V98.4827Z" fill={fillColor} />
      <path d="M5.7931 110.069H0V115.862H5.7931V110.069Z" fill={fillColor} />
      <path d="M5.7931 115.862H0V121.655H5.7931V115.862Z" fill={fillColor} />
      <path d="M5.7931 127.448H0V133.241H5.7931V127.448Z" fill={fillColor} />
      <path d="M5.7931 133.241H0V139.035H5.7931V133.241Z" fill={fillColor} />
      <path d="M5.7931 139.034H0V144.828H5.7931V139.034Z" fill={fillColor} />
      <path d="M5.7931 144.828H0V150.621H5.7931V144.828Z" fill={fillColor} />
      <path d="M5.7931 150.621H0V156.414H5.7931V150.621Z" fill={fillColor} />
      <path d="M5.7931 156.414H0V162.207H5.7931V156.414Z" fill={fillColor} />
      <path d="M5.7931 162.207H0V168H5.7931V162.207Z" fill={fillColor} />
      <path d="M11.5862 0H5.79309V5.7931H11.5862V0Z" fill={fillColor} />
      <path
        d="M11.5862 34.7585H5.79309V40.5516H11.5862V34.7585Z"
        fill={fillColor}
      />
      <path
        d="M11.5862 52.1379H5.79309V57.931H11.5862V52.1379Z"
        fill={fillColor}
      />
      <path
        d="M11.5862 69.5173H5.79309V75.3104H11.5862V69.5173Z"
        fill={fillColor}
      />
      <path
        d="M11.5862 75.3103H5.79309V81.1034H11.5862V75.3103Z"
        fill={fillColor}
      />
      <path
        d="M11.5862 81.1035H5.79309V86.8966H11.5862V81.1035Z"
        fill={fillColor}
      />
      <path
        d="M11.5862 86.8965H5.79309V92.6896H11.5862V86.8965Z"
        fill={fillColor}
      />
      <path
        d="M11.5862 92.6897H5.79309V98.4828H11.5862V92.6897Z"
        fill={fillColor}
      />
      <path
        d="M11.5862 98.4827H5.79309V104.276H11.5862V98.4827Z"
        fill={fillColor}
      />
      <path
        d="M11.5862 104.276H5.79309V110.069H11.5862V104.276Z"
        fill={fillColor}
      />
      <path
        d="M11.5862 110.069H5.79309V115.862H11.5862V110.069Z"
        fill={fillColor}
      />
      <path
        d="M11.5862 127.448H5.79309V133.241H11.5862V127.448Z"
        fill={fillColor}
      />
      <path
        d="M11.5862 162.207H5.79309V168H11.5862V162.207Z"
        fill={fillColor}
      />
      <path d="M17.3793 0H11.5862V5.7931H17.3793V0Z" fill={fillColor} />
      <path
        d="M17.3793 11.5862H11.5862V17.3793H17.3793V11.5862Z"
        fill={fillColor}
      />
      <path
        d="M17.3793 17.3794H11.5862V23.1725H17.3793V17.3794Z"
        fill={fillColor}
      />
      <path
        d="M17.3793 23.1724H11.5862V28.9655H17.3793V23.1724Z"
        fill={fillColor}
      />
      <path
        d="M17.3793 34.7585H11.5862V40.5516H17.3793V34.7585Z"
        fill={fillColor}
      />
      <path
        d="M17.3793 46.3447H11.5862V52.1378H17.3793V46.3447Z"
        fill={fillColor}
      />
      <path
        d="M17.3793 52.1379H11.5862V57.931H17.3793V52.1379Z"
        fill={fillColor}
      />
      <path
        d="M17.3793 69.5173H11.5862V75.3104H17.3793V69.5173Z"
        fill={fillColor}
      />
      <path
        d="M17.3793 81.1035H11.5862V86.8966H17.3793V81.1035Z"
        fill={fillColor}
      />
      <path
        d="M17.3793 98.4827H11.5862V104.276H17.3793V98.4827Z"
        fill={fillColor}
      />
      <path
        d="M17.3793 110.069H11.5862V115.862H17.3793V110.069Z"
        fill={fillColor}
      />
      <path
        d="M17.3793 115.862H11.5862V121.655H17.3793V115.862Z"
        fill={fillColor}
      />
      <path
        d="M17.3793 127.448H11.5862V133.241H17.3793V127.448Z"
        fill={fillColor}
      />
      <path
        d="M17.3793 139.034H11.5862V144.828H17.3793V139.034Z"
        fill={fillColor}
      />
      <path
        d="M17.3793 144.828H11.5862V150.621H17.3793V144.828Z"
        fill={fillColor}
      />
      <path
        d="M17.3793 150.621H11.5862V156.414H17.3793V150.621Z"
        fill={fillColor}
      />
      <path
        d="M17.3793 162.207H11.5862V168H17.3793V162.207Z"
        fill={fillColor}
      />
      <path d="M23.1724 0H17.3793V5.7931H23.1724V0Z" fill={fillColor} />
      <path
        d="M23.1724 11.5862H17.3793V17.3793H23.1724V11.5862Z"
        fill={fillColor}
      />
      <path
        d="M23.1724 17.3794H17.3793V23.1725H23.1724V17.3794Z"
        fill={fillColor}
      />
      <path
        d="M23.1724 23.1724H17.3793V28.9655H23.1724V23.1724Z"
        fill={fillColor}
      />
      <path
        d="M23.1724 34.7585H17.3793V40.5516H23.1724V34.7585Z"
        fill={fillColor}
      />
      <path
        d="M23.1724 46.3447H17.3793V52.1378H23.1724V46.3447Z"
        fill={fillColor}
      />
      <path
        d="M23.1724 57.9312H17.3793V63.7243H23.1724V57.9312Z"
        fill={fillColor}
      />
      <path
        d="M23.1724 63.7241H17.3793V69.5172H23.1724V63.7241Z"
        fill={fillColor}
      />
      <path
        d="M23.1724 69.5173H17.3793V75.3104H23.1724V69.5173Z"
        fill={fillColor}
      />
      <path
        d="M23.1724 75.3103H17.3793V81.1034H23.1724V75.3103Z"
        fill={fillColor}
      />
      <path
        d="M23.1724 86.8965H17.3793V92.6896H23.1724V86.8965Z"
        fill={fillColor}
      />
      <path
        d="M23.1724 115.862H17.3793V121.655H23.1724V115.862Z"
        fill={fillColor}
      />
      <path
        d="M23.1724 127.448H17.3793V133.241H23.1724V127.448Z"
        fill={fillColor}
      />
      <path
        d="M23.1724 139.034H17.3793V144.828H23.1724V139.034Z"
        fill={fillColor}
      />
      <path
        d="M23.1724 144.828H17.3793V150.621H23.1724V144.828Z"
        fill={fillColor}
      />
      <path
        d="M23.1724 150.621H17.3793V156.414H23.1724V150.621Z"
        fill={fillColor}
      />
      <path
        d="M23.1724 162.207H17.3793V168H23.1724V162.207Z"
        fill={fillColor}
      />
      <path d="M28.9655 0H23.1724V5.7931H28.9655V0Z" fill={fillColor} />
      <path
        d="M28.9655 11.5862H23.1724V17.3793H28.9655V11.5862Z"
        fill={fillColor}
      />
      <path
        d="M28.9655 17.3794H23.1724V23.1725H28.9655V17.3794Z"
        fill={fillColor}
      />
      <path
        d="M28.9655 23.1724H23.1724V28.9655H28.9655V23.1724Z"
        fill={fillColor}
      />
      <path
        d="M28.9655 34.7585H23.1724V40.5516H28.9655V34.7585Z"
        fill={fillColor}
      />
      <path
        d="M28.9655 57.9312H23.1724V63.7243H28.9655V57.9312Z"
        fill={fillColor}
      />
      <path
        d="M28.9655 63.7241H23.1724V69.5172H28.9655V63.7241Z"
        fill={fillColor}
      />
      <path
        d="M28.9655 86.8965H23.1724V92.6896H28.9655V86.8965Z"
        fill={fillColor}
      />
      <path
        d="M28.9655 98.4827H23.1724V104.276H28.9655V98.4827Z"
        fill={fillColor}
      />
      <path
        d="M28.9655 104.276H23.1724V110.069H28.9655V104.276Z"
        fill={fillColor}
      />
      <path
        d="M28.9655 110.069H23.1724V115.862H28.9655V110.069Z"
        fill={fillColor}
      />
      <path
        d="M28.9655 127.448H23.1724V133.241H28.9655V127.448Z"
        fill={fillColor}
      />
      <path
        d="M28.9655 139.034H23.1724V144.828H28.9655V139.034Z"
        fill={fillColor}
      />
      <path
        d="M28.9655 144.828H23.1724V150.621H28.9655V144.828Z"
        fill={fillColor}
      />
      <path
        d="M28.9655 150.621H23.1724V156.414H28.9655V150.621Z"
        fill={fillColor}
      />
      <path
        d="M28.9655 162.207H23.1724V168H28.9655V162.207Z"
        fill={fillColor}
      />
      <path d="M34.7587 0H28.9656V5.7931H34.7587V0Z" fill={fillColor} />
      <path
        d="M34.7587 34.7585H28.9656V40.5516H34.7587V34.7585Z"
        fill={fillColor}
      />
      <path
        d="M34.7587 46.3447H28.9656V52.1378H34.7587V46.3447Z"
        fill={fillColor}
      />
      <path
        d="M34.7587 52.1379H28.9656V57.931H34.7587V52.1379Z"
        fill={fillColor}
      />
      <path
        d="M34.7587 57.9312H28.9656V63.7243H34.7587V57.9312Z"
        fill={fillColor}
      />
      <path
        d="M34.7587 69.5173H28.9656V75.3104H34.7587V69.5173Z"
        fill={fillColor}
      />
      <path
        d="M34.7587 81.1035H28.9656V86.8966H34.7587V81.1035Z"
        fill={fillColor}
      />
      <path
        d="M34.7587 92.6897H28.9656V98.4828H34.7587V92.6897Z"
        fill={fillColor}
      />
      <path
        d="M34.7587 98.4827H28.9656V104.276H34.7587V98.4827Z"
        fill={fillColor}
      />
      <path
        d="M34.7587 110.069H28.9656V115.862H34.7587V110.069Z"
        fill={fillColor}
      />
      <path
        d="M34.7587 127.448H28.9656V133.241H34.7587V127.448Z"
        fill={fillColor}
      />
      <path
        d="M34.7587 162.207H28.9656V168H34.7587V162.207Z"
        fill={fillColor}
      />
      <path d="M40.5518 0H34.7587V5.7931H40.5518V0Z" fill={fillColor} />
      <path
        d="M40.5518 5.79321H34.7587V11.5863H40.5518V5.79321Z"
        fill={fillColor}
      />
      <path
        d="M40.5518 11.5862H34.7587V17.3793H40.5518V11.5862Z"
        fill={fillColor}
      />
      <path
        d="M40.5518 17.3794H34.7587V23.1725H40.5518V17.3794Z"
        fill={fillColor}
      />
      <path
        d="M40.5518 23.1724H34.7587V28.9655H40.5518V23.1724Z"
        fill={fillColor}
      />
      <path
        d="M40.5518 28.9656H34.7587V34.7587H40.5518V28.9656Z"
        fill={fillColor}
      />
      <path
        d="M40.5518 34.7585H34.7587V40.5516H40.5518V34.7585Z"
        fill={fillColor}
      />
      <path
        d="M40.5518 46.3447H34.7587V52.1378H40.5518V46.3447Z"
        fill={fillColor}
      />
      <path
        d="M40.5518 57.9312H34.7587V63.7243H40.5518V57.9312Z"
        fill={fillColor}
      />
      <path
        d="M40.5518 69.5173H34.7587V75.3104H40.5518V69.5173Z"
        fill={fillColor}
      />
      <path
        d="M40.5518 81.1035H34.7587V86.8966H40.5518V81.1035Z"
        fill={fillColor}
      />
      <path
        d="M40.5518 92.6897H34.7587V98.4828H40.5518V92.6897Z"
        fill={fillColor}
      />
      <path
        d="M40.5518 104.276H34.7587V110.069H40.5518V104.276Z"
        fill={fillColor}
      />
      <path
        d="M40.5518 115.862H34.7587V121.655H40.5518V115.862Z"
        fill={fillColor}
      />
      <path
        d="M40.5518 127.448H34.7587V133.241H40.5518V127.448Z"
        fill={fillColor}
      />
      <path
        d="M40.5518 133.241H34.7587V139.035H40.5518V133.241Z"
        fill={fillColor}
      />
      <path
        d="M40.5518 139.034H34.7587V144.828H40.5518V139.034Z"
        fill={fillColor}
      />
      <path
        d="M40.5518 144.828H34.7587V150.621H40.5518V144.828Z"
        fill={fillColor}
      />
      <path
        d="M40.5518 150.621H34.7587V156.414H40.5518V150.621Z"
        fill={fillColor}
      />
      <path
        d="M40.5518 156.414H34.7587V162.207H40.5518V156.414Z"
        fill={fillColor}
      />
      <path
        d="M40.5518 162.207H34.7587V168H40.5518V162.207Z"
        fill={fillColor}
      />
      <path
        d="M46.3449 46.3447H40.5518V52.1378H46.3449V46.3447Z"
        fill={fillColor}
      />
      <path
        d="M46.3449 52.1379H40.5518V57.931H46.3449V52.1379Z"
        fill={fillColor}
      />
      <path
        d="M46.3449 63.7241H40.5518V69.5172H46.3449V63.7241Z"
        fill={fillColor}
      />
      <path
        d="M46.3449 69.5173H40.5518V75.3104H46.3449V69.5173Z"
        fill={fillColor}
      />
      <path
        d="M46.3449 81.1035H40.5518V86.8966H46.3449V81.1035Z"
        fill={fillColor}
      />
      <path
        d="M46.3449 86.8965H40.5518V92.6896H46.3449V86.8965Z"
        fill={fillColor}
      />
      <path
        d="M46.3449 110.069H40.5518V115.862H46.3449V110.069Z"
        fill={fillColor}
      />
      <path d="M52.138 0H46.3448V5.7931H52.138V0Z" fill={fillColor} />
      <path
        d="M52.138 5.79321H46.3448V11.5863H52.138V5.79321Z"
        fill={fillColor}
      />
      <path
        d="M52.138 17.3794H46.3448V23.1725H52.138V17.3794Z"
        fill={fillColor}
      />
      <path
        d="M52.138 34.7585H46.3448V40.5516H52.138V34.7585Z"
        fill={fillColor}
      />
      <path
        d="M52.138 40.5518H46.3448V46.3449H52.138V40.5518Z"
        fill={fillColor}
      />
      <path
        d="M52.138 52.1379H46.3448V57.931H52.138V52.1379Z"
        fill={fillColor}
      />
      <path
        d="M52.138 75.3103H46.3448V81.1034H52.138V75.3103Z"
        fill={fillColor}
      />
      <path
        d="M52.138 92.6897H46.3448V98.4828H52.138V92.6897Z"
        fill={fillColor}
      />
      <path
        d="M52.138 98.4827H46.3448V104.276H52.138V98.4827Z"
        fill={fillColor}
      />
      <path
        d="M52.138 115.862H46.3448V121.655H52.138V115.862Z"
        fill={fillColor}
      />
      <path
        d="M52.138 121.655H46.3448V127.448H52.138V121.655Z"
        fill={fillColor}
      />
      <path
        d="M52.138 127.448H46.3448V133.241H52.138V127.448Z"
        fill={fillColor}
      />
      <path
        d="M52.138 133.241H46.3448V139.035H52.138V133.241Z"
        fill={fillColor}
      />
      <path
        d="M52.138 144.828H46.3448V150.621H52.138V144.828Z"
        fill={fillColor}
      />
      <path
        d="M52.138 150.621H46.3448V156.414H52.138V150.621Z"
        fill={fillColor}
      />
      <path d="M52.138 162.207H46.3448V168H52.138V162.207Z" fill={fillColor} />
      <path
        d="M57.931 5.79321H52.1379V11.5863H57.931V5.79321Z"
        fill={fillColor}
      />
      <path
        d="M57.931 11.5862H52.1379V17.3793H57.931V11.5862Z"
        fill={fillColor}
      />
      <path
        d="M57.931 40.5518H52.1379V46.3449H57.931V40.5518Z"
        fill={fillColor}
      />
      <path
        d="M57.931 46.3447H52.1379V52.1378H57.931V46.3447Z"
        fill={fillColor}
      />
      <path
        d="M57.931 52.1379H52.1379V57.931H57.931V52.1379Z"
        fill={fillColor}
      />
      <path
        d="M57.931 75.3103H52.1379V81.1034H57.931V75.3103Z"
        fill={fillColor}
      />
      <path
        d="M57.931 86.8965H52.1379V92.6896H57.931V86.8965Z"
        fill={fillColor}
      />
      <path
        d="M57.931 92.6897H52.1379V98.4828H57.931V92.6897Z"
        fill={fillColor}
      />
      <path
        d="M57.931 104.276H52.1379V110.069H57.931V104.276Z"
        fill={fillColor}
      />
      <path
        d="M57.931 110.069H52.1379V115.862H57.931V110.069Z"
        fill={fillColor}
      />
      <path
        d="M57.931 115.862H52.1379V121.655H57.931V115.862Z"
        fill={fillColor}
      />
      <path
        d="M57.931 127.448H52.1379V133.241H57.931V127.448Z"
        fill={fillColor}
      />
      <path d="M57.931 162.207H52.1379V168H57.931V162.207Z" fill={fillColor} />
      <path d="M63.7241 0H57.931V5.7931H63.7241V0Z" fill={fillColor} />
      <path
        d="M63.7241 17.3794H57.931V23.1725H63.7241V17.3794Z"
        fill={fillColor}
      />
      <path
        d="M63.7241 23.1724H57.931V28.9655H63.7241V23.1724Z"
        fill={fillColor}
      />
      <path
        d="M63.7241 34.7585H57.931V40.5516H63.7241V34.7585Z"
        fill={fillColor}
      />
      <path
        d="M63.7241 40.5518H57.931V46.3449H63.7241V40.5518Z"
        fill={fillColor}
      />
      <path
        d="M63.7241 46.3447H57.931V52.1378H63.7241V46.3447Z"
        fill={fillColor}
      />
      <path
        d="M63.7241 52.1379H57.931V57.931H63.7241V52.1379Z"
        fill={fillColor}
      />
      <path
        d="M63.7241 75.3103H57.931V81.1034H63.7241V75.3103Z"
        fill={fillColor}
      />
      <path
        d="M63.7241 92.6897H57.931V98.4828H63.7241V92.6897Z"
        fill={fillColor}
      />
      <path
        d="M63.7241 98.4827H57.931V104.276H63.7241V98.4827Z"
        fill={fillColor}
      />
      <path
        d="M63.7241 133.241H57.931V139.035H63.7241V133.241Z"
        fill={fillColor}
      />
      <path
        d="M63.7241 139.034H57.931V144.828H63.7241V139.034Z"
        fill={fillColor}
      />
      <path
        d="M63.7241 156.414H57.931V162.207H63.7241V156.414Z"
        fill={fillColor}
      />
      <path d="M63.7241 162.207H57.931V168H63.7241V162.207Z" fill={fillColor} />
      <path d="M69.5172 0H63.7241V5.7931H69.5172V0Z" fill={fillColor} />
      <path
        d="M69.5172 11.5862H63.7241V17.3793H69.5172V11.5862Z"
        fill={fillColor}
      />
      <path
        d="M69.5172 17.3794H63.7241V23.1725H69.5172V17.3794Z"
        fill={fillColor}
      />
      <path
        d="M69.5172 23.1724H63.7241V28.9655H69.5172V23.1724Z"
        fill={fillColor}
      />
      <path
        d="M69.5172 28.9656H63.7241V34.7587H69.5172V28.9656Z"
        fill={fillColor}
      />
      <path
        d="M69.5172 46.3447H63.7241V52.1378H69.5172V46.3447Z"
        fill={fillColor}
      />
      <path
        d="M69.5172 52.1379H63.7241V57.931H69.5172V52.1379Z"
        fill={fillColor}
      />
      <path
        d="M69.5172 57.9312H63.7241V63.7243H69.5172V57.9312Z"
        fill={fillColor}
      />
      <path
        d="M69.5172 63.7241H63.7241V69.5172H69.5172V63.7241Z"
        fill={fillColor}
      />
      <path
        d="M69.5172 69.5173H63.7241V75.3104H69.5172V69.5173Z"
        fill={fillColor}
      />
      <path
        d="M69.5172 75.3103H63.7241V81.1034H69.5172V75.3103Z"
        fill={fillColor}
      />
      <path
        d="M69.5172 86.8965H63.7241V92.6896H69.5172V86.8965Z"
        fill={fillColor}
      />
      <path
        d="M69.5172 98.4827H63.7241V104.276H69.5172V98.4827Z"
        fill={fillColor}
      />
      <path
        d="M69.5172 110.069H63.7241V115.862H69.5172V110.069Z"
        fill={fillColor}
      />
      <path
        d="M69.5172 115.862H63.7241V121.655H69.5172V115.862Z"
        fill={fillColor}
      />
      <path
        d="M69.5172 121.655H63.7241V127.448H69.5172V121.655Z"
        fill={fillColor}
      />
      <path
        d="M69.5172 127.448H63.7241V133.241H69.5172V127.448Z"
        fill={fillColor}
      />
      <path
        d="M69.5172 133.241H63.7241V139.035H69.5172V133.241Z"
        fill={fillColor}
      />
      <path
        d="M69.5172 150.621H63.7241V156.414H69.5172V150.621Z"
        fill={fillColor}
      />
      <path
        d="M69.5172 162.207H63.7241V168H69.5172V162.207Z"
        fill={fillColor}
      />
      <path d="M75.3103 0H69.5172V5.7931H75.3103V0Z" fill={fillColor} />
      <path
        d="M75.3103 5.79321H69.5172V11.5863H75.3103V5.79321Z"
        fill={fillColor}
      />
      <path
        d="M75.3103 11.5862H69.5172V17.3793H75.3103V11.5862Z"
        fill={fillColor}
      />
      <path
        d="M75.3103 17.3794H69.5172V23.1725H75.3103V17.3794Z"
        fill={fillColor}
      />
      <path
        d="M75.3103 34.7585H69.5172V40.5516H75.3103V34.7585Z"
        fill={fillColor}
      />
      <path
        d="M75.3103 52.1379H69.5172V57.931H75.3103V52.1379Z"
        fill={fillColor}
      />
      <path
        d="M75.3103 57.9312H69.5172V63.7243H75.3103V57.9312Z"
        fill={fillColor}
      />
      <path
        d="M75.3103 63.7241H69.5172V69.5172H75.3103V63.7241Z"
        fill={fillColor}
      />
      <path
        d="M75.3103 69.5173H69.5172V75.3104H75.3103V69.5173Z"
        fill={fillColor}
      />
      <path
        d="M75.3103 75.3103H69.5172V81.1034H75.3103V75.3103Z"
        fill={fillColor}
      />
      <path
        d="M75.3103 81.1035H69.5172V86.8966H75.3103V81.1035Z"
        fill={fillColor}
      />
      <path
        d="M75.3103 92.6897H69.5172V98.4828H75.3103V92.6897Z"
        fill={fillColor}
      />
      <path
        d="M75.3103 98.4827H69.5172V104.276H75.3103V98.4827Z"
        fill={fillColor}
      />
      <path
        d="M75.3103 104.276H69.5172V110.069H75.3103V104.276Z"
        fill={fillColor}
      />
      <path
        d="M75.3103 115.862H69.5172V121.655H75.3103V115.862Z"
        fill={fillColor}
      />
      <path
        d="M75.3103 127.448H69.5172V133.241H75.3103V127.448Z"
        fill={fillColor}
      />
      <path
        d="M75.3103 133.241H69.5172V139.035H75.3103V133.241Z"
        fill={fillColor}
      />
      <path
        d="M75.3103 150.621H69.5172V156.414H75.3103V150.621Z"
        fill={fillColor}
      />
      <path
        d="M75.3103 156.414H69.5172V162.207H75.3103V156.414Z"
        fill={fillColor}
      />
      <path
        d="M81.1034 11.5862H75.3103V17.3793H81.1034V11.5862Z"
        fill={fillColor}
      />
      <path
        d="M81.1034 23.1724H75.3103V28.9655H81.1034V23.1724Z"
        fill={fillColor}
      />
      <path
        d="M81.1034 40.5518H75.3103V46.3449H81.1034V40.5518Z"
        fill={fillColor}
      />
      <path
        d="M81.1034 46.3447H75.3103V52.1378H81.1034V46.3447Z"
        fill={fillColor}
      />
      <path
        d="M81.1034 63.7241H75.3103V69.5172H81.1034V63.7241Z"
        fill={fillColor}
      />
      <path
        d="M81.1034 75.3103H75.3103V81.1034H81.1034V75.3103Z"
        fill={fillColor}
      />
      <path
        d="M81.1034 86.8965H75.3103V92.6896H81.1034V86.8965Z"
        fill={fillColor}
      />
      <path
        d="M81.1034 98.4827H75.3103V104.276H81.1034V98.4827Z"
        fill={fillColor}
      />
      <path
        d="M81.1034 115.862H75.3103V121.655H81.1034V115.862Z"
        fill={fillColor}
      />
      <path
        d="M81.1034 121.655H75.3103V127.448H81.1034V121.655Z"
        fill={fillColor}
      />
      <path
        d="M81.1034 127.448H75.3103V133.241H81.1034V127.448Z"
        fill={fillColor}
      />
      <path
        d="M81.1034 150.621H75.3103V156.414H81.1034V150.621Z"
        fill={fillColor}
      />
      <path
        d="M81.1034 156.414H75.3103V162.207H81.1034V156.414Z"
        fill={fillColor}
      />
      <path
        d="M81.1034 162.207H75.3103V168H81.1034V162.207Z"
        fill={fillColor}
      />
      <path
        d="M86.8966 5.79321H81.1035V11.5863H86.8966V5.79321Z"
        fill={fillColor}
      />
      <path
        d="M86.8966 11.5862H81.1035V17.3793H86.8966V11.5862Z"
        fill={fillColor}
      />
      <path
        d="M86.8966 28.9656H81.1035V34.7587H86.8966V28.9656Z"
        fill={fillColor}
      />
      <path
        d="M86.8966 34.7585H81.1035V40.5516H86.8966V34.7585Z"
        fill={fillColor}
      />
      <path
        d="M86.8966 40.5518H81.1035V46.3449H86.8966V40.5518Z"
        fill={fillColor}
      />
      <path
        d="M86.8966 46.3447H81.1035V52.1378H86.8966V46.3447Z"
        fill={fillColor}
      />
      <path
        d="M86.8966 57.9312H81.1035V63.7243H86.8966V57.9312Z"
        fill={fillColor}
      />
      <path
        d="M86.8966 63.7241H81.1035V69.5172H86.8966V63.7241Z"
        fill={fillColor}
      />
      <path
        d="M86.8966 81.1035H81.1035V86.8966H86.8966V81.1035Z"
        fill={fillColor}
      />
      <path
        d="M86.8966 121.655H81.1035V127.448H86.8966V121.655Z"
        fill={fillColor}
      />
      <path
        d="M86.8966 139.034H81.1035V144.828H86.8966V139.034Z"
        fill={fillColor}
      />
      <path
        d="M86.8966 144.828H81.1035V150.621H86.8966V144.828Z"
        fill={fillColor}
      />
      <path
        d="M86.8966 150.621H81.1035V156.414H86.8966V150.621Z"
        fill={fillColor}
      />
      <path d="M92.6896 0H86.8965V5.7931H92.6896V0Z" fill={fillColor} />
      <path
        d="M92.6896 5.79321H86.8965V11.5863H92.6896V5.79321Z"
        fill={fillColor}
      />
      <path
        d="M92.6896 11.5862H86.8965V17.3793H92.6896V11.5862Z"
        fill={fillColor}
      />
      <path
        d="M92.6896 52.1379H86.8965V57.931H92.6896V52.1379Z"
        fill={fillColor}
      />
      <path
        d="M92.6896 57.9312H86.8965V63.7243H92.6896V57.9312Z"
        fill={fillColor}
      />
      <path
        d="M92.6896 63.7241H86.8965V69.5172H92.6896V63.7241Z"
        fill={fillColor}
      />
      <path
        d="M92.6896 86.8965H86.8965V92.6896H92.6896V86.8965Z"
        fill={fillColor}
      />
      <path
        d="M92.6896 98.4827H86.8965V104.276H92.6896V98.4827Z"
        fill={fillColor}
      />
      <path
        d="M92.6896 104.276H86.8965V110.069H92.6896V104.276Z"
        fill={fillColor}
      />
      <path
        d="M92.6896 133.241H86.8965V139.035H92.6896V133.241Z"
        fill={fillColor}
      />
      <path
        d="M92.6896 144.828H86.8965V150.621H92.6896V144.828Z"
        fill={fillColor}
      />
      <path
        d="M92.6896 156.414H86.8965V162.207H92.6896V156.414Z"
        fill={fillColor}
      />
      <path
        d="M92.6896 162.207H86.8965V168H92.6896V162.207Z"
        fill={fillColor}
      />
      <path d="M98.4828 0H92.6897V5.7931H98.4828V0Z" fill={fillColor} />
      <path
        d="M98.4828 17.3794H92.6897V23.1725H98.4828V17.3794Z"
        fill={fillColor}
      />
      <path
        d="M98.4828 34.7585H92.6897V40.5516H98.4828V34.7585Z"
        fill={fillColor}
      />
      <path
        d="M98.4828 46.3447H92.6897V52.1378H98.4828V46.3447Z"
        fill={fillColor}
      />
      <path
        d="M98.4828 52.1379H92.6897V57.931H98.4828V52.1379Z"
        fill={fillColor}
      />
      <path
        d="M98.4828 81.1035H92.6897V86.8966H98.4828V81.1035Z"
        fill={fillColor}
      />
      <path
        d="M98.4828 86.8965H92.6897V92.6896H98.4828V86.8965Z"
        fill={fillColor}
      />
      <path
        d="M98.4828 104.276H92.6897V110.069H98.4828V104.276Z"
        fill={fillColor}
      />
      <path
        d="M98.4828 115.862H92.6897V121.655H98.4828V115.862Z"
        fill={fillColor}
      />
      <path
        d="M98.4828 121.655H92.6897V127.448H98.4828V121.655Z"
        fill={fillColor}
      />
      <path
        d="M98.4828 127.448H92.6897V133.241H98.4828V127.448Z"
        fill={fillColor}
      />
      <path
        d="M98.4828 144.828H92.6897V150.621H98.4828V144.828Z"
        fill={fillColor}
      />
      <path
        d="M98.4828 150.621H92.6897V156.414H98.4828V150.621Z"
        fill={fillColor}
      />
      <path
        d="M98.4828 156.414H92.6897V162.207H98.4828V156.414Z"
        fill={fillColor}
      />
      <path
        d="M104.276 5.79321H98.4827V11.5863H104.276V5.79321Z"
        fill={fillColor}
      />
      <path
        d="M104.276 17.3794H98.4827V23.1725H104.276V17.3794Z"
        fill={fillColor}
      />
      <path
        d="M104.276 40.5518H98.4827V46.3449H104.276V40.5518Z"
        fill={fillColor}
      />
      <path
        d="M104.276 46.3447H98.4827V52.1378H104.276V46.3447Z"
        fill={fillColor}
      />
      <path
        d="M104.276 52.1379H98.4827V57.931H104.276V52.1379Z"
        fill={fillColor}
      />
      <path
        d="M104.276 69.5173H98.4827V75.3104H104.276V69.5173Z"
        fill={fillColor}
      />
      <path
        d="M104.276 75.3103H98.4827V81.1034H104.276V75.3103Z"
        fill={fillColor}
      />
      <path
        d="M104.276 98.4827H98.4827V104.276H104.276V98.4827Z"
        fill={fillColor}
      />
      <path
        d="M104.276 104.276H98.4827V110.069H104.276V104.276Z"
        fill={fillColor}
      />
      <path
        d="M104.276 110.069H98.4827V115.862H104.276V110.069Z"
        fill={fillColor}
      />
      <path
        d="M104.276 115.862H98.4827V121.655H104.276V115.862Z"
        fill={fillColor}
      />
      <path
        d="M104.276 139.034H98.4827V144.828H104.276V139.034Z"
        fill={fillColor}
      />
      <path
        d="M104.276 150.621H98.4827V156.414H104.276V150.621Z"
        fill={fillColor}
      />
      <path d="M110.069 0H104.276V5.7931H110.069V0Z" fill={fillColor} />
      <path
        d="M110.069 11.5862H104.276V17.3793H110.069V11.5862Z"
        fill={fillColor}
      />
      <path
        d="M110.069 34.7585H104.276V40.5516H110.069V34.7585Z"
        fill={fillColor}
      />
      <path
        d="M110.069 40.5518H104.276V46.3449H110.069V40.5518Z"
        fill={fillColor}
      />
      <path
        d="M110.069 52.1379H104.276V57.931H110.069V52.1379Z"
        fill={fillColor}
      />
      <path
        d="M110.069 57.9312H104.276V63.7243H110.069V57.9312Z"
        fill={fillColor}
      />
      <path
        d="M110.069 63.7241H104.276V69.5172H110.069V63.7241Z"
        fill={fillColor}
      />
      <path
        d="M110.069 81.1035H104.276V86.8966H110.069V81.1035Z"
        fill={fillColor}
      />
      <path
        d="M110.069 86.8965H104.276V92.6896H110.069V86.8965Z"
        fill={fillColor}
      />
      <path
        d="M110.069 92.6897H104.276V98.4828H110.069V92.6897Z"
        fill={fillColor}
      />
      <path
        d="M110.069 110.069H104.276V115.862H110.069V110.069Z"
        fill={fillColor}
      />
      <path
        d="M110.069 115.862H104.276V121.655H110.069V115.862Z"
        fill={fillColor}
      />
      <path
        d="M110.069 127.448H104.276V133.241H110.069V127.448Z"
        fill={fillColor}
      />
      <path
        d="M110.069 133.241H104.276V139.035H110.069V133.241Z"
        fill={fillColor}
      />
      <path
        d="M110.069 150.621H104.276V156.414H110.069V150.621Z"
        fill={fillColor}
      />
      <path
        d="M110.069 156.414H104.276V162.207H110.069V156.414Z"
        fill={fillColor}
      />
      <path
        d="M110.069 162.207H104.276V168H110.069V162.207Z"
        fill={fillColor}
      />
      <path d="M115.862 0H110.069V5.7931H115.862V0Z" fill={fillColor} />
      <path
        d="M115.862 17.3794H110.069V23.1725H115.862V17.3794Z"
        fill={fillColor}
      />
      <path
        d="M115.862 23.1724H110.069V28.9655H115.862V23.1724Z"
        fill={fillColor}
      />
      <path
        d="M115.862 28.9656H110.069V34.7587H115.862V28.9656Z"
        fill={fillColor}
      />
      <path
        d="M115.862 52.1379H110.069V57.931H115.862V52.1379Z"
        fill={fillColor}
      />
      <path
        d="M115.862 75.3103H110.069V81.1034H115.862V75.3103Z"
        fill={fillColor}
      />
      <path
        d="M115.862 81.1035H110.069V86.8966H115.862V81.1035Z"
        fill={fillColor}
      />
      <path
        d="M115.862 115.862H110.069V121.655H115.862V115.862Z"
        fill={fillColor}
      />
      <path
        d="M115.862 121.655H110.069V127.448H115.862V121.655Z"
        fill={fillColor}
      />
      <path
        d="M115.862 127.448H110.069V133.241H115.862V127.448Z"
        fill={fillColor}
      />
      <path
        d="M115.862 144.828H110.069V150.621H115.862V144.828Z"
        fill={fillColor}
      />
      <path
        d="M115.862 150.621H110.069V156.414H115.862V150.621Z"
        fill={fillColor}
      />
      <path
        d="M115.862 162.207H110.069V168H115.862V162.207Z"
        fill={fillColor}
      />
      <path d="M121.655 0H115.862V5.7931H121.655V0Z" fill={fillColor} />
      <path
        d="M121.655 5.79321H115.862V11.5863H121.655V5.79321Z"
        fill={fillColor}
      />
      <path
        d="M121.655 11.5862H115.862V17.3793H121.655V11.5862Z"
        fill={fillColor}
      />
      <path
        d="M121.655 23.1724H115.862V28.9655H121.655V23.1724Z"
        fill={fillColor}
      />
      <path
        d="M121.655 34.7585H115.862V40.5516H121.655V34.7585Z"
        fill={fillColor}
      />
      <path
        d="M121.655 40.5518H115.862V46.3449H121.655V40.5518Z"
        fill={fillColor}
      />
      <path
        d="M121.655 52.1379H115.862V57.931H121.655V52.1379Z"
        fill={fillColor}
      />
      <path
        d="M121.655 81.1035H115.862V86.8966H121.655V81.1035Z"
        fill={fillColor}
      />
      <path
        d="M121.655 86.8965H115.862V92.6896H121.655V86.8965Z"
        fill={fillColor}
      />
      <path
        d="M121.655 92.6897H115.862V98.4828H121.655V92.6897Z"
        fill={fillColor}
      />
      <path
        d="M121.655 98.4827H115.862V104.276H121.655V98.4827Z"
        fill={fillColor}
      />
      <path
        d="M121.655 115.862H115.862V121.655H121.655V115.862Z"
        fill={fillColor}
      />
      <path
        d="M121.655 121.655H115.862V127.448H121.655V121.655Z"
        fill={fillColor}
      />
      <path
        d="M121.655 127.448H115.862V133.241H121.655V127.448Z"
        fill={fillColor}
      />
      <path
        d="M121.655 133.241H115.862V139.035H121.655V133.241Z"
        fill={fillColor}
      />
      <path
        d="M121.655 139.034H115.862V144.828H121.655V139.034Z"
        fill={fillColor}
      />
      <path
        d="M121.655 144.828H115.862V150.621H121.655V144.828Z"
        fill={fillColor}
      />
      <path
        d="M121.655 156.414H115.862V162.207H121.655V156.414Z"
        fill={fillColor}
      />
      <path
        d="M121.655 162.207H115.862V168H121.655V162.207Z"
        fill={fillColor}
      />
      <path
        d="M127.448 52.1379H121.655V57.931H127.448V52.1379Z"
        fill={fillColor}
      />
      <path
        d="M127.448 57.9312H121.655V63.7243H127.448V57.9312Z"
        fill={fillColor}
      />
      <path
        d="M127.448 92.6897H121.655V98.4828H127.448V92.6897Z"
        fill={fillColor}
      />
      <path
        d="M127.448 115.862H121.655V121.655H127.448V115.862Z"
        fill={fillColor}
      />
      <path
        d="M127.448 139.034H121.655V144.828H127.448V139.034Z"
        fill={fillColor}
      />
      <path
        d="M127.448 144.828H121.655V150.621H127.448V144.828Z"
        fill={fillColor}
      />
      <path
        d="M127.448 156.414H121.655V162.207H127.448V156.414Z"
        fill={fillColor}
      />
      <path d="M133.241 0H127.448V5.7931H133.241V0Z" fill={fillColor} />
      <path
        d="M133.241 5.79321H127.448V11.5863H133.241V5.79321Z"
        fill={fillColor}
      />
      <path
        d="M133.241 11.5862H127.448V17.3793H133.241V11.5862Z"
        fill={fillColor}
      />
      <path
        d="M133.241 17.3794H127.448V23.1725H133.241V17.3794Z"
        fill={fillColor}
      />
      <path
        d="M133.241 23.1724H127.448V28.9655H133.241V23.1724Z"
        fill={fillColor}
      />
      <path
        d="M133.241 28.9656H127.448V34.7587H133.241V28.9656Z"
        fill={fillColor}
      />
      <path
        d="M133.241 34.7585H127.448V40.5516H133.241V34.7585Z"
        fill={fillColor}
      />
      <path
        d="M133.241 46.3447H127.448V52.1378H133.241V46.3447Z"
        fill={fillColor}
      />
      <path
        d="M133.241 52.1379H127.448V57.931H133.241V52.1379Z"
        fill={fillColor}
      />
      <path
        d="M133.241 57.9312H127.448V63.7243H133.241V57.9312Z"
        fill={fillColor}
      />
      <path
        d="M133.241 75.3103H127.448V81.1034H133.241V75.3103Z"
        fill={fillColor}
      />
      <path
        d="M133.241 104.276H127.448V110.069H133.241V104.276Z"
        fill={fillColor}
      />
      <path
        d="M133.241 110.069H127.448V115.862H133.241V110.069Z"
        fill={fillColor}
      />
      <path
        d="M133.241 115.862H127.448V121.655H133.241V115.862Z"
        fill={fillColor}
      />
      <path
        d="M133.241 127.448H127.448V133.241H133.241V127.448Z"
        fill={fillColor}
      />
      <path
        d="M133.241 139.034H127.448V144.828H133.241V139.034Z"
        fill={fillColor}
      />
      <path
        d="M133.241 156.414H127.448V162.207H133.241V156.414Z"
        fill={fillColor}
      />
      <path
        d="M133.241 162.207H127.448V168H133.241V162.207Z"
        fill={fillColor}
      />
      <path d="M139.035 0H133.241V5.7931H139.035V0Z" fill={fillColor} />
      <path
        d="M139.035 34.7585H133.241V40.5516H139.035V34.7585Z"
        fill={fillColor}
      />
      <path
        d="M139.035 52.1379H133.241V57.931H139.035V52.1379Z"
        fill={fillColor}
      />
      <path
        d="M139.035 57.9312H133.241V63.7243H139.035V57.9312Z"
        fill={fillColor}
      />
      <path
        d="M139.035 63.7241H133.241V69.5172H139.035V63.7241Z"
        fill={fillColor}
      />
      <path
        d="M139.035 75.3103H133.241V81.1034H139.035V75.3103Z"
        fill={fillColor}
      />
      <path
        d="M139.035 81.1035H133.241V86.8966H139.035V81.1035Z"
        fill={fillColor}
      />
      <path
        d="M139.035 86.8965H133.241V92.6896H139.035V86.8965Z"
        fill={fillColor}
      />
      <path
        d="M139.035 98.4827H133.241V104.276H139.035V98.4827Z"
        fill={fillColor}
      />
      <path
        d="M139.035 104.276H133.241V110.069H139.035V104.276Z"
        fill={fillColor}
      />
      <path
        d="M139.035 115.862H133.241V121.655H139.035V115.862Z"
        fill={fillColor}
      />
      <path
        d="M139.035 139.034H133.241V144.828H139.035V139.034Z"
        fill={fillColor}
      />
      <path
        d="M139.035 150.621H133.241V156.414H139.035V150.621Z"
        fill={fillColor}
      />
      <path
        d="M139.035 156.414H133.241V162.207H139.035V156.414Z"
        fill={fillColor}
      />
      <path d="M144.828 0H139.034V5.7931H144.828V0Z" fill={fillColor} />
      <path
        d="M144.828 11.5862H139.034V17.3793H144.828V11.5862Z"
        fill={fillColor}
      />
      <path
        d="M144.828 17.3794H139.034V23.1725H144.828V17.3794Z"
        fill={fillColor}
      />
      <path
        d="M144.828 23.1724H139.034V28.9655H144.828V23.1724Z"
        fill={fillColor}
      />
      <path
        d="M144.828 34.7585H139.034V40.5516H144.828V34.7585Z"
        fill={fillColor}
      />
      <path
        d="M144.828 52.1379H139.034V57.931H144.828V52.1379Z"
        fill={fillColor}
      />
      <path
        d="M144.828 57.9312H139.034V63.7243H144.828V57.9312Z"
        fill={fillColor}
      />
      <path
        d="M144.828 63.7241H139.034V69.5172H144.828V63.7241Z"
        fill={fillColor}
      />
      <path
        d="M144.828 81.1035H139.034V86.8966H144.828V81.1035Z"
        fill={fillColor}
      />
      <path
        d="M144.828 86.8965H139.034V92.6896H144.828V86.8965Z"
        fill={fillColor}
      />
      <path
        d="M144.828 92.6897H139.034V98.4828H144.828V92.6897Z"
        fill={fillColor}
      />
      <path
        d="M144.828 115.862H139.034V121.655H144.828V115.862Z"
        fill={fillColor}
      />
      <path
        d="M144.828 121.655H139.034V127.448H144.828V121.655Z"
        fill={fillColor}
      />
      <path
        d="M144.828 127.448H139.034V133.241H144.828V127.448Z"
        fill={fillColor}
      />
      <path
        d="M144.828 133.241H139.034V139.035H144.828V133.241Z"
        fill={fillColor}
      />
      <path
        d="M144.828 139.034H139.034V144.828H144.828V139.034Z"
        fill={fillColor}
      />
      <path
        d="M144.828 144.828H139.034V150.621H144.828V144.828Z"
        fill={fillColor}
      />
      <path d="M150.621 0H144.828V5.7931H150.621V0Z" fill={fillColor} />
      <path
        d="M150.621 11.5862H144.828V17.3793H150.621V11.5862Z"
        fill={fillColor}
      />
      <path
        d="M150.621 17.3794H144.828V23.1725H150.621V17.3794Z"
        fill={fillColor}
      />
      <path
        d="M150.621 23.1724H144.828V28.9655H150.621V23.1724Z"
        fill={fillColor}
      />
      <path
        d="M150.621 34.7585H144.828V40.5516H150.621V34.7585Z"
        fill={fillColor}
      />
      <path
        d="M150.621 46.3447H144.828V52.1378H150.621V46.3447Z"
        fill={fillColor}
      />
      <path
        d="M150.621 69.5173H144.828V75.3104H150.621V69.5173Z"
        fill={fillColor}
      />
      <path
        d="M150.621 92.6897H144.828V98.4828H150.621V92.6897Z"
        fill={fillColor}
      />
      <path
        d="M150.621 98.4827H144.828V104.276H150.621V98.4827Z"
        fill={fillColor}
      />
      <path
        d="M150.621 115.862H144.828V121.655H150.621V115.862Z"
        fill={fillColor}
      />
      <path
        d="M150.621 121.655H144.828V127.448H150.621V121.655Z"
        fill={fillColor}
      />
      <path
        d="M150.621 127.448H144.828V133.241H150.621V127.448Z"
        fill={fillColor}
      />
      <path
        d="M150.621 133.241H144.828V139.035H150.621V133.241Z"
        fill={fillColor}
      />
      <path
        d="M150.621 144.828H144.828V150.621H150.621V144.828Z"
        fill={fillColor}
      />
      <path
        d="M150.621 156.414H144.828V162.207H150.621V156.414Z"
        fill={fillColor}
      />
      <path
        d="M150.621 162.207H144.828V168H150.621V162.207Z"
        fill={fillColor}
      />
      <path d="M156.414 0H150.621V5.7931H156.414V0Z" fill={fillColor} />
      <path
        d="M156.414 11.5862H150.621V17.3793H156.414V11.5862Z"
        fill={fillColor}
      />
      <path
        d="M156.414 17.3794H150.621V23.1725H156.414V17.3794Z"
        fill={fillColor}
      />
      <path
        d="M156.414 23.1724H150.621V28.9655H156.414V23.1724Z"
        fill={fillColor}
      />
      <path
        d="M156.414 34.7585H150.621V40.5516H156.414V34.7585Z"
        fill={fillColor}
      />
      <path
        d="M156.414 57.9312H150.621V63.7243H156.414V57.9312Z"
        fill={fillColor}
      />
      <path
        d="M156.414 69.5173H150.621V75.3104H156.414V69.5173Z"
        fill={fillColor}
      />
      <path
        d="M156.414 75.3103H150.621V81.1034H156.414V75.3103Z"
        fill={fillColor}
      />
      <path
        d="M156.414 81.1035H150.621V86.8966H156.414V81.1035Z"
        fill={fillColor}
      />
      <path
        d="M156.414 98.4827H150.621V104.276H156.414V98.4827Z"
        fill={fillColor}
      />
      <path
        d="M156.414 104.276H150.621V110.069H156.414V104.276Z"
        fill={fillColor}
      />
      <path
        d="M156.414 110.069H150.621V115.862H156.414V110.069Z"
        fill={fillColor}
      />
      <path
        d="M156.414 115.862H150.621V121.655H156.414V115.862Z"
        fill={fillColor}
      />
      <path
        d="M156.414 121.655H150.621V127.448H156.414V121.655Z"
        fill={fillColor}
      />
      <path
        d="M156.414 139.034H150.621V144.828H156.414V139.034Z"
        fill={fillColor}
      />
      <path
        d="M156.414 150.621H150.621V156.414H156.414V150.621Z"
        fill={fillColor}
      />
      <path d="M162.207 0H156.414V5.7931H162.207V0Z" fill={fillColor} />
      <path
        d="M162.207 34.7585H156.414V40.5516H162.207V34.7585Z"
        fill={fillColor}
      />
      <path
        d="M162.207 46.3447H156.414V52.1378H162.207V46.3447Z"
        fill={fillColor}
      />
      <path
        d="M162.207 57.9312H156.414V63.7243H162.207V57.9312Z"
        fill={fillColor}
      />
      <path
        d="M162.207 75.3103H156.414V81.1034H162.207V75.3103Z"
        fill={fillColor}
      />
      <path
        d="M162.207 81.1035H156.414V86.8966H162.207V81.1035Z"
        fill={fillColor}
      />
      <path
        d="M162.207 86.8965H156.414V92.6896H162.207V86.8965Z"
        fill={fillColor}
      />
      <path
        d="M162.207 92.6897H156.414V98.4828H162.207V92.6897Z"
        fill={fillColor}
      />
      <path
        d="M162.207 98.4827H156.414V104.276H162.207V98.4827Z"
        fill={fillColor}
      />
      <path
        d="M162.207 121.655H156.414V127.448H162.207V121.655Z"
        fill={fillColor}
      />
      <path
        d="M162.207 127.448H156.414V133.241H162.207V127.448Z"
        fill={fillColor}
      />
      <path
        d="M162.207 133.241H156.414V139.035H162.207V133.241Z"
        fill={fillColor}
      />
      <path
        d="M162.207 139.034H156.414V144.828H162.207V139.034Z"
        fill={fillColor}
      />
      <path
        d="M162.207 156.414H156.414V162.207H162.207V156.414Z"
        fill={fillColor}
      />
      <path
        d="M162.207 162.207H156.414V168H162.207V162.207Z"
        fill={fillColor}
      />
      <path d="M168 0H162.207V5.7931H168V0Z" fill={fillColor} />
      <path d="M168 5.79321H162.207V11.5863H168V5.79321Z" fill={fillColor} />
      <path d="M168 11.5862H162.207V17.3793H168V11.5862Z" fill={fillColor} />
      <path d="M168 17.3794H162.207V23.1725H168V17.3794Z" fill={fillColor} />
      <path d="M168 23.1724H162.207V28.9655H168V23.1724Z" fill={fillColor} />
      <path d="M168 28.9656H162.207V34.7587H168V28.9656Z" fill={fillColor} />
      <path d="M168 34.7585H162.207V40.5516H168V34.7585Z" fill={fillColor} />
      <path d="M168 46.3447H162.207V52.1378H168V46.3447Z" fill={fillColor} />
      <path d="M168 52.1379H162.207V57.931H168V52.1379Z" fill={fillColor} />
      <path d="M168 63.7241H162.207V69.5172H168V63.7241Z" fill={fillColor} />
      <path d="M168 75.3103H162.207V81.1034H168V75.3103Z" fill={fillColor} />
      <path d="M168 81.1035H162.207V86.8966H168V81.1035Z" fill={fillColor} />
      <path d="M168 121.655H162.207V127.448H168V121.655Z" fill={fillColor} />
      <path d="M168 133.241H162.207V139.035H168V133.241Z" fill={fillColor} />
      <path d="M168 144.828H162.207V150.621H168V144.828Z" fill={fillColor} />
      <path d="M168 150.621H162.207V156.414H168V150.621Z" fill={fillColor} />
      <rect x="68" y="68" width="32" height="32" rx="2" fill={ninjaIconColor} />
      <g clipPath="url(#clip0_1520_129204)">
        <path
          d="M83.9995 78.0006H84C81.5048 78.0006 79.2773 78.699 77.8106 80.0963C77.7445 80.0101 77.6911 79.9365 77.6564 79.8807C77.4351 79.5282 77.1768 79.1148 76.9884 78.6976C76.9537 78.6202 76.9232 78.5476 76.897 78.4792C77.0592 78.519 77.2528 78.5476 77.4618 78.534C77.6606 78.5213 77.8748 78.4529 78.0656 78.3095C78.2479 78.1726 78.3548 78.0081 78.4162 77.8763C78.5282 77.6363 78.54 77.3982 78.5386 77.2534C78.5362 76.9379 78.4607 76.569 78.3745 76.2338C78.195 75.5401 77.8387 73.0281 77.6217 72.5002L76.0359 74.9448C76.2145 75.3784 76.4428 75.9943 76.6012 76.5427C76.5642 76.5352 76.5253 76.5292 76.4854 76.524C76.3382 76.5057 76.1198 76.501 75.8775 76.5887C75.2873 76.8024 75.0942 77.3251 75.0347 77.6481C74.9123 78.3156 75.1415 78.9882 75.3647 79.4827C75.5981 80.0007 75.8315 80.1999 75.8315 80.1999L76.4742 80.9415L76.8623 81.2874C76.5548 81.7979 76.3176 82.3642 76.1737 82.9942C75.8456 82.8263 75.4622 82.6299 75.1256 82.4082C75.0632 82.367 75.0061 82.3276 74.954 82.2896C75.0867 82.2643 75.2353 82.2212 75.374 82.1448C75.5057 82.0721 75.6211 81.9568 75.6829 81.7979C75.742 81.6465 75.735 81.5002 75.7125 81.391C75.6717 81.1923 75.562 81.0268 75.4893 80.9288C75.3318 80.7156 75.097 80.4896 74.8706 80.2904C74.4028 79.8779 72.9126 78.2888 72.5001 78.0006L72.6061 80.1704C72.9445 80.4071 73.4081 80.7507 73.7897 81.0718C73.7601 81.0788 73.7301 81.0868 73.6997 81.0967C73.5886 81.1318 73.4339 81.1993 73.3087 81.3366C73.004 81.6718 73.1282 82.0885 73.2464 82.3267C73.4911 82.8188 73.9832 83.2013 74.3831 83.4648C74.8017 83.7409 75.0628 83.8009 75.0628 83.8009L75.8765 84.0967L76.0223 84.1327C76.0139 84.279 75.9993 84.421 75.9993 84.5724C75.9993 88.9552 79.5811 93.5002 83.9995 93.5002C88.4179 93.5002 91.9997 88.9552 91.9997 84.5724C91.9997 80.1896 88.4179 78.0006 83.9995 78.0006ZM78.4397 89.7502C78.4397 89.7502 78.4373 89.747 78.4364 89.7456C77.2354 88.2512 76.5004 86.3279 76.5004 84.4374C76.5004 80.4779 79.725 78.5002 83.7028 78.5002C86.4112 78.5002 88.7704 79.4176 90.0004 81.2527C88.7048 79.7162 86.5186 78.9484 84.0403 78.9484C80.0625 78.9484 76.8379 80.926 76.8379 84.8856C76.8379 86.5918 77.4365 88.3252 78.4364 89.7456C78.4378 89.747 78.4387 89.7488 78.4401 89.7502H78.4397ZM84 90.4998C80.6306 90.4998 77.3751 87.6516 77.3751 84.7881C77.3751 81.9245 80.6306 82.5601 84 82.5601C87.3693 82.5601 90.6248 81.9245 90.6248 84.7881C90.6248 87.6516 87.3693 90.4998 84 90.4998Z"
          fill={fillColor}
        />
        <path
          d="M89.4206 84.9599C89.7014 85.6748 89.1117 86.5269 88.1029 86.8635C87.0947 87.1996 86.0494 86.893 85.7686 86.1777C85.4878 85.4629 86.0526 85.1671 87.0614 84.8305C88.0697 84.494 89.1398 84.2446 89.4206 84.9599ZM78.5794 84.9599C78.2986 85.6748 78.8883 86.5269 79.897 86.8635C80.9053 87.1996 81.9506 86.893 82.2314 86.1777C82.5122 85.4629 81.9473 85.1671 80.9386 84.8305C79.9303 84.494 78.8601 84.2446 78.5794 84.9599Z"
          fill={fillColor}
        />
      </g>
      <defs>
        <clipPath id="clip0_1520_129204">
          <rect
            width="24"
            height="24"
            fill={fillColor}
            transform="translate(72 72)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
